// extracted by mini-css-extract-plugin
export default {"container":"top-products__container___kysSi","header":"top-products__header___LgMjJ","innerContainer":"top-products__innerContainer___Ib39W"};